(function (exports) {
    "use strict";

    var AUTHORIZATION_KEY = "clcCredentials";
    var TOKEN_KEY = "token";

    function getAuthorization() {
        return JSON.parse(sessionStorage.getItem(AUTHORIZATION_KEY));
    }

    function setAuthorization(authorization) {

        sessionStorage.setItem(AUTHORIZATION_KEY, JSON.stringify(authorization));

        return authorization;
    }

    exports.logOut = function () {
        sessionStorage.removeItem(AUTHORIZATION_KEY);
    };

    function getUrlQueryParameters() {
        var url = window.location.href;
        var matches = url.match("[?](.*)");

        if (!matches) {
            return [];
        }

        return matches[1].split("&").map(function (parameter) {
            var keyValue = parameter.split("=");
            return { key: keyValue[0], value: decodeURIComponent(keyValue[1]) };
        });
    }

    function extractValueFromUrl(key) {
        var filteredParameters = getUrlQueryParameters().filter(function (keyValue) {
            return keyValue.key == key;
        });

        return filteredParameters.length > 0 ? filteredParameters[0].value : null;
    }

    function extractTokenFromUrl() {
        return extractValueFromUrl(TOKEN_KEY);
    }

    function exchange(token, domain) {
        var request = { token: token, domain: domain };
        var requestString = JSON.stringify(request);

        return Application.promisify($.ajax({url: "/sso/exchange", method: "POST", data: requestString, contentType: "application/json; charset=UTF-8"}));
    }

    function resetUrl(authorization) {
        var url = window.location.href;
        var regEx = new RegExp("([?&])token=.*?(&|#|$)(.*)", "gi");

        if (regEx.test(url)) {
            var hash;

            hash = url.split("#");
            url = hash[0].replace(regEx, "$1$3").replace(/(&|\?)$/, "");

            if (typeof hash[1] !== "undefined" && hash[1] !== null) {
                url += "#" + hash[1];
            }

            window.location.href = url;
        }

        // We just want to pass the authorization down the promise chain
        return authorization;
    }

    function redirectToSignIn() {
        var redirect = window.location.href;
        console.log("The redirect would be ", redirect);

        if (!extractTokenFromUrl()) {
            window.location.href = Environment.CONTROL_PORTAL_URL + "/auth/sso?ReturnUrl=" + redirect;
        }
    }

    function promiseAuthorization() {
        var authorization = getAuthorization();

        if (authorization) {
            return Promise.resolve(authorization);
        }

        var token = extractTokenFromUrl();

        if (!token) {
            return Promise.reject(Error("Unauthenticated"));
        }

        var domain = window.location.hostname;

        return exchange(token, domain).then(setAuthorization).then(resetUrl);
    }

    exports.authorize = function authorize() {
        return new Promise(function (resolve, reject) {
            return promiseAuthorization().then(resolve).catch(function (e) {
                redirectToSignIn();
                reject(e);
            });
        });
    };
}(typeof exports === "undefined" ? this.Sso = {} : exports));


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/js/sso.jasset
 ** module id = 996
 ** module chunks = 0
 **/